import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductStocksService } from 'src/app/services/product-stocks.service';

@Component({
  selector: 'app-add-stock',
  templateUrl: './add-stock.component.html',
  styleUrls: ['./add-stock.component.scss']
})
export class AddStockComponent implements OnInit {
  @Input() productId!: number;
  @Input() partnerId!: number;
  @Input() productVariantId?: number;
  @Input() productName?: string;
  @Input() variantName?: string;

  @Output() stockAdded = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<void>();

  addStockForm!: FormGroup;
  loading = false;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private stockService: ProductStocksService
  ) {}

  ngOnInit(): void {
    this.addStockForm = this.fb.group({
      quantity: [null, [Validators.required, Validators.min(1)]],
      unitCost: [null],
      batchNumber: [''],
      expiryDate: [''],
      note: ['']
    });
  }

  async submit(): Promise<void> {
    if (this.addStockForm.invalid) {
      this.addStockForm.markAllAsTouched();
      return;
    }

    if (!this.productId || !this.partnerId) {
      this.errorMessage = 'Product or partner is missing';
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    const formValue = this.addStockForm.value;

    const payload = {
      productId: Number(this.productId),
      partnerId: Number(this.partnerId),
      productVariantId: this.productVariantId
        ? Number(this.productVariantId)
        : undefined,
      quantity: Number(formValue.quantity),
      unitCost: formValue.unitCost ? Number(formValue.unitCost) : undefined,
      batchNumber: formValue.batchNumber || undefined,
      expiryDate: formValue.expiryDate || undefined,
      note: formValue.note || undefined
    };

    try {
      const response = await this.stockService.addStock(payload);

      this.addStockForm.reset();
      this.stockAdded.emit(response);

    } catch (error: any) {
      this.errorMessage = this.getBackendErrorMessage(error);

    } finally {
      this.loading = false;
    }
  }

  cancel(): void {
    if (this.loading) {
      return;
    }

    this.cancelled.emit();
  }

  private getBackendErrorMessage(error: any): string {
    if (error?.error?.message) {
      if (Array.isArray(error.error.message)) {
        return error.error.message.join(', ');
      }

      return error.error.message;
    }

    if (error?.message) {
      return error.message;
    }

    return 'Failed to add stock';
  }
}